import { formatSettings } from 'FRONTEND/utils/backendApi/settingsApi';
import { BOOTH_TELECONSULTATION, VIDEO_CONSULTATION } from 'FRONTEND/utils/constants';
import { apiStatusError, fetchError } from 'FRONTEND/utils/errors';
import { API_USERS_PATH } from 'FRONTEND/utils/routes';

export const formatExpert = (rawExpert) => {
  return {
    ...formatSettings(rawExpert),
    alias: rawExpert.alias || '',
    id: rawExpert.user_id || rawExpert.id,
    login: rawExpert.login,
    picture: rawExpert.picture,
    tenantList: Object.values(rawExpert?.common_tenant_ids || {}),
    prNumber: rawExpert.pr_number || null,
    stripe: {
      id: rawExpert.stripe_connected_account_id,
      status: rawExpert.stripe_connected_account_status,
    },
  };
};

export const getExperts = async({ name, tenantId, appointmentType, startDate, endDate, hasPayment = false }) => {
  try {
    const rightForSearch = window.branding === 'msf' ? 'appointments-list' : 'consultations-diagnose';
    const searchParams = new URLSearchParams({ right: rightForSearch });
    if (typeof tenantId === 'string') {
      searchParams.append('tenant', tenantId);
    } else if (tenantId?.length) {
      tenantId.forEach((tenant) => {
        searchParams.append('tenant', tenant);
      });
    }
    if (name != null) {
      searchParams.append('_q', name);
    }
    if (appointmentType) {
      searchParams.append('appointment-type', appointmentType === BOOTH_TELECONSULTATION ? VIDEO_CONSULTATION : appointmentType);
    }
    if (startDate != null) {
      searchParams.append('appointment-start', startDate);
    }
    if (endDate != null) {
      searchParams.append('appointment-end', endDate);
    }
    if (hasPayment) {
      searchParams.append('can-accept-payments', 1);
    }
    const rawExperts = await fetch(`${API_USERS_PATH}?${searchParams}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });
    return rawExperts.map(formatExpert);
  } catch (error) {
    throw fetchError({ error });
  }
};
